import React from "react";
import i18n, { fromSyntax } from "../../../i18n";
import Chart from "../../chart/";
import { Card } from "antd";
import { Metrics } from "../../../theme/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { MathUtil, isFunction, ArrayUtil, isAlive, OrgUtil } from "../../../util";
import { GraphDataMaker } from "../../../util/helper/graph";
import { OHeader } from "../../text/OText";
import { getSplitRatio } from "../generics";
import { GRAPH, MAX_RETURNING_TIME } from "../../../constants/limit";

const ReturningChart = ({
	header = i18n.t("session_by.returning"),
	onHeaderClick,
	data, previousData, style,
	height = GRAPH.HEIGHT, colorType,
	showValue = true,
	showLegend = true,
	isVertical = false, onClick, short,
	removeZero = false,
	isLoadMore,
})=>{
	const mutatePercentConfigs = {
		itemKey:"title"
	};
	const mutateObject = GraphDataMaker.createReturningObject(data);
	let mutatePercentData = GraphDataMaker.makeRenderDataOfObject(mutateObject, k=>k, (k,o)=>o, removeZero, mutatePercentConfigs); 
	let prevMutatePercentData = undefined;
	if(isAlive(previousData)){
		prevMutatePercentData = GraphDataMaker.makeRenderDataOfObject(
			GraphDataMaker.createReturningObject(previousData), k=>k, (k,o)=>o, removeZero,mutatePercentConfigs
		);
	}
	return <GraphCard 
		style={{...style, marginTop:Metrics.button.spaceMargin}} 
		header={header}
		onHeaderClick={onHeaderClick}
		height={height}
		isVertical = {isVertical}
		chartWidthRatio={getSplitRatio(short)}
		fullLegendOnVertical={false}
		showLegend={showLegend}
		graph={<Chart.ProgressReturningBar 
			style={style}
			header={header}
			data={mutateObject}
			height={height}
			colorType={colorType}
			isVertical={isVertical}
			onClick={onClick}
			showSize = {5}
			isLoadMore={isLoadMore}
			sort={false} 
		/>
		}
		legend={showLegend && !short? 
			<DataPercentList 
				percentDatas={mutatePercentData}
				compareDatas={prevMutatePercentData}
				textKey={mutatePercentConfigs.itemKey} valueKey='count'
				percentKey='percent'
				visualColorKey={colorType}
				showColor={false}
				showValue={showValue}
				onClick={onClick}
			/> : undefined
		}
	/>;
};
export default ReturningChart;


// WEBPACK FOOTER //
// ./src/components/report/generics/ReportReturningChart.js